import { useMemo } from 'react';

import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetVenues } from 'src/hooks/api/useVenuesEndpoint';
import { PrimaryTag } from 'src/pages/People/Edit/components/Information/components/MobileLists.styled';
import { useGetConfig } from 'src/hooks/api/useConfigEndpoint';
import { useSetCurrentUserPreferences } from 'src/hooks/api/useUsersEndpoint';

interface DrawerSelectOption {
  value: string;
  label: string | React.ReactNode;
  disabled?: boolean;
}

export const useMakeDefault = (activeItem: string | string[] | undefined) => {
  const { t } = useTranslation();
  const { data: configData } = useGetConfig();
  const defaultVenue = configData?.defaultVenue;
  const { data: venues } = useGetVenues();
  const { mutate: setCurrentUserPreferences } = useSetCurrentUserPreferences();

  const venuesToSelectMapped = useMemo(
    () =>
      venues?.map((venue) => ({
        value: venue.id || '',
        label: venue.name || '',
      })),
    [venues],
  );

  const handleMakeDefault = (e: React.MouseEvent<HTMLElement, MouseEvent>, selectedItem?: string) => {
    e.stopPropagation();

    if (selectedItem === defaultVenue?.id) {
      setCurrentUserPreferences({
        clientPreferences: {
          defaultVenueId: null,
        },
      });
      return;
    }
    const nextDefault = venuesToSelectMapped?.find((venue) => venue.value === selectedItem);

    setCurrentUserPreferences({
      clientPreferences: {
        defaultVenueId: nextDefault?.value,
      },
    });
  };

  const makeDefault = (item: DrawerSelectOption) => {
    if (activeItem === item.value && defaultVenue?.id === item.value) {
      return (
        <Button onClick={(e) => handleMakeDefault(e, `${item.value}`)} type="text">
          {t('interactions.clear')}
        </Button>
      );
    }

    if (item.value === defaultVenue?.id) {
      return <PrimaryTag>{t('interactions.default')}</PrimaryTag>;
    }

    return (
      <Button onClick={(e) => handleMakeDefault(e, `${item.value}`)} type="text">
        {t('interactions.makeDefault')}
      </Button>
    );
  };

  return {
    defaultVenue,
    makeDefault,
  };
};
